<!--suppress JSUnusedGlobalSymbols -->
<template>
    <div class="app large">
        <div id="loadingAjax"></div>
        <!--Will be full width-->
        <h1 v-html="articleData.title || '...'"></h1>
        <span class="article-header-info">
            <span class="article-header-info-date">
                {{ articleData.formatted_date || '...' }}
                {{ (articleData.categories || []).includes(798) ? "|" : ""}}
                {{ (articleData.categories || []).includes(798) ? `By ${articleData.customs.author_of_the_feature}` : ""}}
            </span>
            <tags :categories="articleData.categories || []"></tags>
        </span>
        <!--main content-->
        <main v-if="articleData.content">
            <div class="image-wrapper">
                <intrinsic :small="articleData.media[thumbnail].url"
                           :floatRatio="articleData.media[thumbnail].height / articleData.media[thumbnail].width"
                           :alt="articleData.media[thumbnail].alt"></intrinsic>
                <span class="image-alt" v-if="articleData.media[thumbnail].alt">
                    {{ articleData.media[thumbnail].alt }}
                </span>
            </div>
            <span class="image-data">
                <span class="feature-author"
                      v-if="articleData && articleData.customs && articleData.customs.author_of_the_feature">
                    Author: {{ articleData.customs.author_of_the_feature }}
                </span>
                <span class="article-header-info-date">
                    {{ articleData.formatted_date || '...' }}
                </span>
            </span>
            <hr>
            <social></social>
            <article-content :namingIsHard="articleData.content"></article-content>
            <social></social>
            <donate-banner></donate-banner>
            <news-heading :subtitle="true">
                Read More
            </news-heading>
            <readmore :features="false" :rows="2" thumbnail_size="medium" :currentArticle="articleData.id"></readmore>
        </main>
        <main v-else>
            <loading></loading>
        </main>
        <sidebar></sidebar>
        <!--Will be full width-->
        <div class="full-width">
            <lazy-component>
                <news-heading :subtitle="true">
                    Features
                </news-heading>
                <readmore :news="false" :currentArticle="articleData.id" :key="articleData.id" :columns="4"
                          :amount="24"></readmore>
            </lazy-component>
        </div>
        <div class="full-width">
            <lazy-component @show="openPage(1)">
                <our-articles :articles="articles" :loading="loading" :nextPage="nextPage"
                              :finished="finished"></our-articles>
            </lazy-component>
        </div>
    </div>
</template>

<script>
	import Sidebar from "./sidebar.vue";
	import Readmore from "./readmore.vue";
	import Intrinsic from "../shared/intrinsic.vue";
	import Social from "../shared/social.vue";
	import Loading from "../shared/loading.vue";
	import axios from "axios";
	import OtherNews from "../news/other-news.vue";
	import Vue from "vue";
	import VueLazyload from 'vue-lazyload';
	import Tags from "./tags.vue";
	import OurArticles from "../news/our-articles.vue";
	import NewsMain from "../news/news-main.vue";
	import NewsHeading from "../news/news-heading.vue";
	import VueMasonryPlugin from 'vue-masonry';
	import ArticleContent from "./article-content.vue";
	import DonateBanner from "../shared/donate-banner.vue";


	Vue.use(VueMasonryPlugin);

	Vue.use(VueLazyload, {
		lazyComponent: true
	});

	export default {
		name: "article",
		props: [
			"article"
		],
		components: {
			Sidebar,
			Readmore,
			Intrinsic,
			Social,
			Loading,
			OurArticles,
			Tags,
			NewsMain,
			NewsHeading,
			OtherNews,
			//Custom
			ArticleContent,
			//Banners
			DonateBanner
		},
		watch: {
			// call again the method if the route changes
			'$route': 'getArticle'
		},
		updated() {
			twttr.widgets.load();
			FB.XFBML.parse();
		},
		mounted() {
			window.scroll(0, 0);
			this.title = document.querySelector("title");
			twttr.widgets.load();
		},
		created() {
			if (window.__article) {
				this.articleData = window.__article;
			} else {
				this.fetchArticleWithSlug(this.article).then((response) => {
					this.articleData = response.data;
				});
			}
		},
		data: function () {
			return {
				articleData: {
					empty: true
				},
				articles: [],
				loading: false,
				currentPage: 0,
				finished: false,
				thumbnail: "large",
				title: null,
			}
		},
		methods: {
			changePageTitle(title) {
				let txt = document.createElement("textarea");
				txt.innerHTML = title;
				this.title.text = txt.value;
			},
			scrollTop() {
				window.scroll(0, 0);
			},
			getArticle() {
				this.articleData = {};
				this.scrollTop();
				this.fetchArticleWithSlug(this.article).then((response) => {
					this.articleData = response.data;
					this.changePageTitle(response.data.title);
					if (this.ga() !== null) {
						this.ga()('set', 'page', location.pathname);
						this.ga()('send', 'pageview');
					}
				})
			},
			fetchArticleWithSlug(slug) {
				if (sessionStorage.getItem(slug)) {
					return Promise.resolve(JSON.parse(sessionStorage.getItem(slug)));
				} else {
					return axios.get("/wp-json/news/v2/post", {
						params: {
							slug: slug,
							customs: true
						}
					}).then((response) => {
						sessionStorage.setItem(slug, JSON.stringify(response));
						return response;
					})
				}
			},
			openPage(page, amount = 12) {
				this.currentPage = page;
				this.loading = true;
				axios.get("/wp-json/news/v2/readmore", {
					params: {
						page: page,
						amount,
						thumbnail_size: "medium",
						description: true,
						features: false,
					}
				})
					.then(({data}) => {
						if (!data.length) {
							this.finished = true;
						} else {
							this.finished = false;
							this.articles = this.articles.concat(data);
						}
					})
					.then(() => {
						this.loading = false;
					})
			},
			nextPage() {
				this.openPage(++this.currentPage);
			},
			ga() {
				let ga = window.GoogleAnalyticsObject;
				if (typeof ga === "string") {
					if (typeof window[ga] === "function") {
						return window[ga]
					} else {
						return null;
					}
				} else {
					return null;
				}
			}
		}
	}
</script>

<style lang="scss" src="./article.scss"></style>


// WEBPACK FOOTER //
// article-js.vue?148d6b33